import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import { DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH } from '../../../Document.constants'
import { DOCUMENT_FOLDER_FORM_FIELD_NAME_NAME } from '../../DocumentFolderForm.constants'

function NameField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      autoFocus
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('DocumentsFolder.NameFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH}
      name={DOCUMENT_FOLDER_FORM_FIELD_NAME_NAME}
      placeholder={t('DocumentsFolder.NameFieldPlaceholderKey')}
    />
  )
}

export default NameField
